import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as ExportTripHistoryIcon } from 'assets/icons/document-upload.svg';
import {
  BaseModal,
  Button,
  DateRangeSelector,
  ENUM_DATE_RANGE,
  Input,
  ToastMessage,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'utils/api';
interface ExportTripHistoryModalType {
  show: boolean;
  onClose: () => void;
  rider?: { riderId: string; partnerId: string };
}

interface ExportTripHistoryModalFooterType {
  loading: boolean;
  onConfirm: () => void;
}

const ExportTripHistoryModalFooter: FC<ExportTripHistoryModalFooterType> = ({
  onConfirm,
  loading
}) => (
  <Button
    small
    color='primary'
    variant='block'
    className='mx-auto'
    loading={loading}
    onClick={onConfirm}>
    Confirm
  </Button>
);

const ExportTripHistoryModal: FC<ExportTripHistoryModalType> = ({ show, onClose, rider }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [dateRange, setDateRange] = useState(getDateRangeSelector(ENUM_DATE_RANGE.ALL));

  useEffect(() => {
    if (show) {
      const defaultEmail = localStorage.getItem(STORAGE_KEYS.EMAIL);
      setEmail(defaultEmail ?? '');
      setDateRange(getDateRangeSelector(ENUM_DATE_RANGE.ALL));
    }
  }, [show]);

  const sendDetails = async () => {
    if (rider) {
      try {
        setLoading(true);
        const { startDate: start_time, endDate: end_time } = dateRange;

        await apiService.post(
          `logistics/${rider?.partnerId}/riders/${rider?.riderId}/trips/export`,
          {
            data: {
              start_time,
              end_time,
              email
            }
          }
        );
        toast(<ToastMessage type='success' message='Trips exported successfully' />);

        onClose();
      } catch (err: any) {
        toast(err.response.data.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Export Trip History'
      description='Provide your mail address to have orders sent to your mail'
      titleIcon={<ExportTripHistoryIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={<ExportTripHistoryModalFooter loading={loading} onConfirm={sendDetails} />}>
      <div className='space-y-3'>
        <Input
          label='Email Address'
          placeholder='paul@gmail.com'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name='email'
        />
        <div>
          <p className='font-medium text-base mb-2'>Duration</p>
          <DateRangeSelector
            showTime
            defaultRange={ENUM_DATE_RANGE.ALL}
            onChange={(v) => setDateRange(v.date)}
            className='py-5 text-base border-gray-6'
            isInput
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default ExportTripHistoryModal;
